const SCREEN_LABELS = {
    home_tab: '홈',
    my_gather_tab: '내 모임',
    story_tab: '이야기',
    chat_tab: '채팅',
    my_info_tab: '내 정보',
};

const ACTION_LABELS = {
    find_gathering_funny: '재미 모임 찾기',
    find_gathering_class: '배움 모임 찾기',
    recommend_schedule: '추천 일정 보기',
    recommend_schedule_more: '추천 일정 더 보기',
    recent_create_gather: '최근 개설 모임 보기',
    recent_create_gather_more: '최근 개설 모임 더 보기',
    my_info_edit: '내 정보 수정',
    my_point: '포인트 내역 보기',
    my_payment_history: '결제 내역 보기',
    product_count_select: '상품 수량 선택',
    product_purchase: '상품 구매 진행',
    story_container: '이야기 상세 보기',
    alarm_button: '알림 열기',
    setting_button: '설정 열기',
    channel_talk_button: '문의 열기',
    popular_story_scroll_end: '인기 이야기 끝까지 보기',
};

const PREFIX_LABELS = [
    ['story_category_', '이야기 카테고리 · '],
    ['product_sort_', '상품 정렬 · '],
    ['product_category_', '상품 카테고리 · '],
    ['product_', '상품 보기 · '],
    ['pay_', '결제 수단 선택 · '],
    ['main_banner_', '메인 배너 보기 · '],
    ['my_info_mini_app_', '내 정보 메뉴 · '],
    ['우모소_', '홈 추천 메뉴 · '],
];

const humanize = (value) => `${value || '알 수 없음'}`.replaceAll('_', ' ').trim();

export const getScreenLabel = (name) => SCREEN_LABELS[name] || humanize(name);

export const getActionLabel = (name) => {
    if (ACTION_LABELS[name]) return ACTION_LABELS[name];
    const prefix = PREFIX_LABELS.find(([key]) => `${name}`.startsWith(key));
    if (!prefix) return humanize(name);
    return `${prefix[1]}${humanize(`${name}`.slice(prefix[0].length))}`;
};

export const getPlatformLabel = (name) => {
    if (name === 'android') return 'Android';
    if (name === 'ios') return 'iOS';
    if (name === 'web') return 'Web';
    return '확인되지 않음';
};
